export default __webpack_public_path__ + "static/media/GoodMannersWithYourSiblings_03.fd400f13.png";